import { Order, OrderType } from 'store/cart/types';
import { IntlShape } from 'react-intl';

import { formatCurrency } from './formatCurrency';
import { formatSummaryValues } from './formatSummaryValues';

export const getPrice = (
  isFreeCart: boolean,
  cart: Order,
  freeText: string,
  locale: string,
  intl: IntlShape,
  creditPrice?: number,
): string => {
  const { currencyType, total } = formatSummaryValues(cart?.total_summary);

  if (!isFreeCart && currencyType) {
    const formattedPrice = formatCurrency(total, currencyType, locale);
    const showCredits = creditPrice != null && creditPrice > 0;
    if (showCredits) {
      const formattedCredits = intl.formatMessage({ id: 'credits' }, { count: creditPrice });
      if (total === 0 || total < 0.01) {
        return formattedCredits;
      }
      return `${formattedPrice} / ${formattedCredits}`;
    }
    return formattedPrice;
  }

  if (cart.type === OrderType.RESOURCE_BOOKING) {
    return '';
  }

  return freeText;
};
